import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, TextField, Typography, Modal, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import OtpInput from 'react-otp-input';
import { useAuth } from '../../../context/AuthContext';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: 2,
  outline: "none",
  boxShadow: 24,
  p: 3,
};


export default function LoginForm() {
  const navigate = useNavigate();
  const { singIn, getVerificationCode } = useAuth();
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  

  const handleClose = () => {
    setOpen(false);
  };

  const getVerification = async () => {
    try {
      setLoading(true)
      await getVerificationCode({ email: username });
      setError(null);
      setOpen(true);
      setLoading(false)
    } catch (error) {
      const message = error?.response?.data?.message || "Por favor verifique sus credenciales e intente nuevamente."
      setError(message);
    }
  }

  useEffect(()=>{

    const handleClick = async () => {

      try {
        if(password.toString().length !== 6){
          return;
        }
        setLoading(true);
        await singIn(username, password);
        navigate('/', { replace: true });
      } catch (error) {
        const message = error?.response?.data?.message || "Por favor verifique sus credenciales e intente nuevamente."
        setError(message);
      } finally {
        setLoading(false)
      }

    };

    handleClick();

  },[password])

  return (
    <>
      <Stack spacing={3}>
        <TextField name="email" size='small' label="Email address" onChange={(e) => { setUsername(e.target.value) }} />
      </Stack>

      <LoadingButton sx={{ my: 2, textTransform: "none" }} fullWidth size="large" type="submit" variant="contained" onClick={getVerification}
        disabled={!username || loading}
      >
        {loading ? 'Enviando...' : 'Enviar código de verificación'}
      </LoadingButton>
      < Typography variant="subtitle2" sx={{ textAlign: 'center', color: "red" }} mt={1}>
        {error && error}
      </Typography>


      <Modal
        open={open}
        onClose={()=>{
          handleClose();
          setLoading(false);
          setPassword("");
          setError(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>

          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{mb: 2}}>
            Ingrese el código que le enviamos al correo:
          </Typography>

          <OtpInput
            value={password}
            shouldAutoFocus
            onChange={(value)=>setPassword(Number(value))}
            inputType='number'
            numInputs={6}
            renderSeparator={<span style={{color:"transparent"}}>-</span>}
            renderInput={(props) => <input {...props} style={{outline:"none", width: "100%",height:"30px",border:"none",borderRadius:"10px",backgroundColor: "lightblue",padding:10,textAlign:"center" }} />}
          />

< Typography variant="subtitle2" sx={{ textAlign: 'center', color: "red" }} mt={1}>
        {error && error}
      </Typography>

        </Box>
      </Modal>

    </>
  );
}
